const translationIT = {
  'About Us': 'Riguardo a Noi',
  'SwapAround is a new social network for swapping. You can swap anything, your surpluses, items or services. Anything you can think of and responds to our categories.':
    'SwapAround è un nuovo social network per lo scambio. Puoi scambiare qualsiasi cosa, le tue eccedenze, i tuoi articoli e servizi. Tutto ciò che puoi pensare e risponde alle nostre categorie.',
  //FAQ Translation
  'How do I use SwapAround?': 'How do I use SwapAround?',
  'Do I necessarily have to ask only for surpluses for my Offers?':
    'Do I necessarily have to ask only for surpluses for my Offers?',
  'What are SwapAroud policies?': 'What are SwapAroud policies?',
  'What do I need to create a profile?': 'What do I need to create a profile?',
  'What kind of profile photo should I upload?':
    'What kind of profile photo should I upload?',
  'When will my Offers go online?': 'When will my Offers go online?',
  'What do I get for the membership I pay to SwapAround?':
    'What do I get for the membership I pay to SwapAround?',

  //1
  '<ol> <li>SwapAround has the easiest possible manipulation. Even elderly people can manage. The User signs to be either an &bdquo;I seek&ldquo; or an &bdquo;I Offer&ldquo; User. Everyone can be both and switch in their account between the profiles. Users can log in with an email address, Facebook account or Google account.</li> <li>You must fill all profile details, including a short introduction e.g. &ldquo;Ecology mined woman on maternity leave who likes to give new life to old things&rdquo;, &ldquo;Stay at home mother who welcomes every item for her household&rdquo; and upload a profile picture.</li> <li>As &bdquo;I Offer&ldquo; user, you create your Offer (plus icon on &bdquo;I Offer &lsquo;s&ldquo; profile) &ndash; it can be anything &ndash; things you don&rsquo;t need anymore, things you make and you welcome to swap them for other things, services you provide and want to swap them for other services or items. You have to upload a picture of your Offer, fill the description, write down for what you want to swap them, how many portions/items/seats you have available, date and time of availability and your Offer is online. If someone is interested in your Offer, you will get a notification either as a chat request or a direct Order. You can chat with the &bdquo;I seek&ldquo; User about an additional questions regarding your Offer.&nbsp;</li> <li>As a Guest you set filters &ndash; distance from the place where you are located at the moment, time, category of item you are seeking or use a key word search. Then SwapAround gives you matches with the Offers and you can start browsing.&nbsp;</li> <li>After Swap is due, you can rate under each profile, which builds trust in the community.</li> <li>When you see that a User on the other side is violating our Terms and Conditions, you can report them.</li> </ol>': 
  '<ol> <li>SwapAround h  as the easiest possible manipulation. Even elderly people can manage. The User signs to be either an &bdquo;I seek&ldquo; or an &bdquo;I Offer&ldquo; User. Everyone can be both and switch in their account between the profiles. Users can log in with an email address, Facebook account or Google account.</li> <li>You must fill all profile details, including a short introduction e.g. &ldquo;Ecology mined woman on maternity leave who likes to give new life to old things&rdquo;, &ldquo;Stay at home mother who welcomes every item for her household&rdquo; and upload a profile picture.</li> <li>As &bdquo;I Offer&ldquo; user, you create your Offer (plus icon on &bdquo;I Offer &lsquo;s&ldquo; profile) &ndash; it can be anything &ndash; things you don&rsquo;t need anymore, things you make and you welcome to swap them for other things, services you provide and want to swap them for other services or items. You have to upload a picture of your Offer, fill the description, write down for what you want to swap them, how many portions/items/seats you have available, date and time of availability and your Offer is online. If someone is interested in your Offer, you will get a notification either as a chat request or a direct Order. You can chat with the &bdquo;I seek&ldquo; User about an additional questions regarding your Offer.&nbsp;</li> <li>As a Guest you set filters &ndash; distance from the place where you are located at the moment, time, category of item you are seeking or use a key word search. Then SwapAround gives you matches with the Offers and you can start browsing.&nbsp;</li> <li>After Swap is due, you can rate under each profile, which builds trust in the community.</li> <li>When you see that a User on the other side is violating our Terms and Conditions, you can report them.</li> </ol>',

  //2
  '<p>Not at all. It is only about demand and supply. If people accept your Offers swapped for services or new items, it is totally up to you what you ask for. The only thing you can not ask for is money.</p>':
    '<p>Not at all. It is only about demand and supply. If people accept your Offers swapped for services or new items, it is totally up to you what you ask for. The only thing you can not ask for is money.</p>',
  //3
  '<p>SwapAround has a strict non-discrimination policy. SwapAround is at its core, an open community dedicated to bringing the world closer together by fostering meaningful, shared experiences among people from all parts of the world. Our community includes people from virtually every country on the globe. It is an incredibly diverse community, drawing together individuals of different cultures, values, and norms.<br />The SwapAround community is committed to building a world where people from every background feel welcome and respected. This commitment rests on two foundational principles that apply all to SwapAround Users inclusion and respect. Our shared commitment to these principles enables every User to feel welcome on SwapAround no matter who they are, where they come from, how they worship, or whom they love.</p>':
    '<p>SwapAround has a strict non-discrimination policy. SwapAround is at its core, an open community dedicated to bringing the world closer together by fostering meaningful, shared experiences among people from all parts of the world. Our community includes people from virtually every country on the globe. It is an incredibly diverse community, drawing together individuals of different cultures, values, and norms.<br />The SwapAround community is committed to building a world where people from every background feel welcome and respected. This commitment rests on two foundational principles that apply all to SwapAround Users inclusion and respect. Our shared commitment to these principles enables every User to feel welcome on SwapAround no matter who they are, where they come from, how they worship, or whom they love.</p>',
  //4
  '<p>Only a smartphone, tablet, laptop or a PC to use the Platform. Creating of the profile is doable only via MyCookAround platform and takes approximately 10 minutes.</p>':
    '<p>Only a smartphone, tablet, laptop or a PC to use the Platform. Creating of the profile is doable only via MyCookAround platform and takes approximately 10 minutes.</p>',
  //5
  '<p>It has to be a genuine photo of yourself.</p>':
    '<p>It has to be a genuine photo of yourself.</p>',
  //6
  '<p> Immediately. You don‘t have to wait for any approval. </p>':
    '<p> Immediately. You don‘t have to wait for any approval. </p>',
  //7
  '<p>A powerful online presence and technical support. SwapAround actively markets your Offers. A dedicated team verifies Users &sbquo; reviews, making sure they are legitimate. This gives you credibility and helps future swappers make the decision to stay with you. 24/7 support is here for you and your swappers.</p>':
    '<p>A powerful online presence and technical support. SwapAround actively markets your Offers. A dedicated team verifies Users &sbquo; reviews, making sure they are legitimate. This gives you credibility and helps future swappers make the decision to stay with you. 24/7 support is here for you and your swappers.</p>',

  //Profile translation
  SEARCH_FOR: 'Cerca...',
  'Became i seek': `Diventa Cerco`,
  'Became i offer': `Diventa Offro`,
  Seek: 'Domanda',
  Offer: 'Offerta',
  Profile: `Profilo`,
  'Payment Card': `Carta di Pagamento`,
  Settings: `Impostazioni`,
  Share: `Condividi`,
  'Bank Account': `Conto bancario`,
  Logout: `Disconnettersi`,
  'Contact Support': `Contatta il Sapporto`,
  'Contact Us': `Contattaci`,
  FAQ: 'FAQ',
  'Terms and Conditions': 'Termini a Condizioni',
  'Edit Profile': `Modifica Profilo`,
  'My Account': `Il mio account`,
  'Push Notifications': `Notifiche push`,
  'Sign out': `Disconnessione`,
  'Current Orders': `Ordini correnti`,
  'Past Orders': `Ordini passati`,
  'Newest First': `Prima i più nuovi`,
  Oldest: `il più vecchio`,
  'Filter by': `Filtra per`,
  'Have any question or need help?': `Hai domande o hai bisogno di aiuto?`,
  'Feel free to write us. We will answer you as soon as possible.': `Sentiti libero di scriverci. Le risponderemo il più presto possibile.`,
  Send: `Mandare`,
  'My Offer': `La mia offerta`,
  'User Reviews': `Recensioni degli utenti`,
  'Meal Details': `Dettagli del pasto`,
  'Order Details': `Dettagli dell'ordine`,
  'Cannot find offers': 'Impossibile trovare le offerte',
  'Searching Offers around': 'Ricerca di offerte in giro',
  Order: 'Scambiare',
  Save: 'Salvare',
  'Currently you have no past orders':
    'Momentálně nemáte žádné předchozí objednávky',
  'Currently you have no orders': 'Attualmente non hai ordini',
  'Back to my orders': 'Torna ai miei ordini',
  'Waiting for Accept': 'In attesa di accettare',
  Refused: 'rifiutato',
  Ready: 'Pronto',
  'Ready in': 'Pronto in',
  ARRIVE_IN: 'Arrivare in',
  'per item': 'a articolo',
  Quantity: 'Quantità',
  Available: 'A disposizione',
  'I offers Details': 'Offro dettagli',
  'I seeks Details': 'Cerco dettagli',
  'i offer': 'Offro',
  'i seek': 'Cerco',
  'Take away': 'Porta via',
  'Eat with': 'Mangia con',
  Both: 'Tutti e due',
  'Total Price': 'Prezzo totale',
  'Your Payout': 'Il tuo pagamento',
  Cook: 'Offro',
  Guest: 'Cerco',
  Cooks: 'Offro',
  Guests: 'Cerco',
  'Currently the cooks have no added offer':
    'Attualmente i cuochi non hanno alcuna offerta aggiuntiva',
  'Report i offer': 'Rapporto che offro',
  'Report i seek': 'Segnala che cerco',
  Cancel: 'Annulla',
  'New Offer': 'Nuova offerta',
  General: 'Generale',
  'Number of items available': 'Il numero di Articoli disponibili',
  'Price per portion/item': 'Prezzo per porzione / articolo',
  'Date and Time': `La data e l’ora`,
  CONSUMPTION_TYPE_MESSAGE:
    'Il cibo è disponibile in loco, ossia l’ospite deve consumare nel luogo di preparazione',
  NO_OFFER_LISTED: 'Non hai ancora nessuna offerta',
  Done: 'Fatto',
  Category: 'Categoria',
  Select: 'Scelta',
  Name: 'Nome',
  Description: 'Descrizione',
  Restrictions: 'Limitazioni',
  'Type of Consumption': 'Tipo di consumo',
  TODAY: 'Oggi',
  YESTEDAY: 'Ieri',
  RATE_YOUR_GUEST: 'Assegna punti a tuo Ospite!',
  RATE_YOUR_COOK: 'Assegna punti a tuo Cuoco!',
  WRITE_A_NOTE: 'Scrivi una nota',
  CHANGE_PASSWORD: 'Cambia password',
  RESET_PASSWORD: 'Resetta la password',
  RESET_YOUR_PASSWORD: 'Resetujte své heslo',
  RESET_PASSWORD_SUCCESSFUL: 'La tua password è stata aggiornata con successo.',
  YOUR_EMAIL: `tua email`,
  WRITE_MESSAGE: 'Scrivi tuo messagio',
  DETAILS: 'Dettagli',
  ADD_OFFER: 'Aggiungi offerta',
  MEAL_NOT_EXISTS: 'Il pasto non esiste',
  DELETE: 'Elimina',
  DELETE_MESSAGE: 'Vuoi davvero eliminare questa offerta?',
  USERNAME: 'Nome utente',
  PHONE_NUMBER: 'Numero di telefono',
  STREET: 'Strada',
  CITY: 'Città',
  NOTE: 'Nota',
  ZIP_CODE: `CAP`,
  REGION: 'Regione',

  MY_ORDERS: 'Miei Ordini',
  MY_OFFERS: 'Mie Offerte',
  GO_TO_OFFERS: 'Vai sulle Mie Offerte',
  GO_TO_ORDERS: 'Vai sulle Miei Ordini',
  YOUR_OFFER: 'La tua offerta',
  WAS_DELETED: `è stata eliminata dall’Amministratore`,

  NOTIFICATIONS: 'Notificazione',
  NEW_ORDER: 'Nuovo ordine',
  ORDER_ACCEPTED_NOTIFICATION: 'Ordine accettato',
  ORDER_REFUSED_NOTIFICATION: 'Ordine rifiutato',
  NEW_ORDER_NOTIFICATION_MESSAGE: 'Hai una nuova richiesta d’ordine',
  OFFER_DELETED: 'Offerta eliminata',
  OFFER_DELETED_NOTIFICATION_MESSAGE:
    'La tua offerta è stata eliminata dall’Amministratore',
  Reason: 'Motivo',
  SWITCH_ACCOUNT_MESSAGE:
    'Si prega di cambiare account per visualizzare questo Ordine',

  //Modals
  ORDER_ACCEPTED: `Hai accettato l'ordine!`,
  Continue: 'Continua',
  ACCEPT: 'Accettare',
  REPORT_REASON: `Il tuo motivo è stato inviato all'ospite.`,
  'Write a reason of reporting': `Scrivi un motivo per segnalare`,
  REFUSE_ORDER: `Rifiuta l'ordine`,
  ACCEPTED_ORDER: 'Il tuo ordine è stato accettato!',
  PICKUP_ADDRESS: `Ritira il tuo ordine al seguente indirizzo all'indirizzo`,
  REFUSE_MESSAGE: 'Il tuo ordine è stato rifiutato!',
  ORDER_SENT: 'Il tuo ordine è stato inviato!',
  PROSSECCING_TO_COOK: 'Procedere al Offro',
  SET_VISIBLE: 'Stai per impostare questo pasto come invisibile.',
  VISIBLE_MESSAGE: `Questo può essere utile, se sai che cucinerai il pasto più tardi in futuro
  e non voglio eliminarlo.`,
  DONT_SHOW_AGAIN: 'Non mostrare più',
  LOGIN_MODAL: 'Devi creare un account o effettuare il login per ordinare!',
  TAKE_A_MOMENT: 'Ci vorrà solo un momento.',
  NO_CHAT_MESSAGE: 'Non hai ancora nessun messaggio',
  OFFER_ORDER: 'Scambiare',
  ADDRESS: 'Indirizzo',
  ADDRESS_NOTES: 'Nota (piano, numero di appartamento, etc.)',
  CONSTANT_OFFER: 'Offerta costante',
  'a.m': 'Mattina',
  'p.m': 'Pomeriggio',
  Evening: 'Sera',
  AVAILABLE_DATES: 'Date disponibili',
  VIEW_DATES: 'visualizzare le date disponibili',
  NO_DATES: 'nessuna data disponibile',
  TIME_SCHEDULE: 'Orario',
  NO_TIME_SCHEDULE: 'Nessun programma di tempo',
  'New Card': 'Nuova carta',

  NO_REVIEWS: 'Ancora nessuna recensione',
  'Sending Order': 'Ordine di invio',
  'Logging in': 'Entrando',
  'accepted order': 'ordine accettato',
  REPORT_MESSAGE:
    'Grazie per la tua segnalazione Lo esamineremo il prima possibile.',
  'Adding Report': 'Aggiunta di un rapporto',
  CREATE_PROFILE: 'Crea un profilo',
  // BUTTONS
  SEND_ORDER: 'Invia Ordine',
  NAVIGATE: 'Naviga',
  SKIP: 'Saltare',
  SUBMIT: 'Invia',
  'Signing you up': 'Ti sto iscrivendo',
  'Creating profile': 'Creare un profilo',

  // AUTHENTICATION
  CREATE_AN_ACCOUNT: 'Crea un Profile',
  OR_SIGN_IN: 'O accedi con',
  EMAIL_LOGIN: 'Accedi con email',
  FACEBOOK_LOGIN: 'Accedi con Facebook',
  GOOGLE_LOGIN: 'Accedi con Google',
  LOGIN: 'Accedi',
  PASSWORD: 'Password',
  PASSWORD_AGAIN: 'Ripeti la password',
  NAME: 'Nome',
  SURNAME: 'Cognome',
  CREATE_ACCOUNT: 'Crea un Account',
  CREATE: 'Crea',
  I_AGREE_WITH: `Sono d'accordo con`,
  TERMS_AND_CONDITIONS: 'Termini e Condizioni',
  FORGOT_PASSWORD: 'Password dimenticato',
  FORGOT_YOUR_PASSWORD: 'Hai dimenticato la password?',
  TO_RESET_PASSWORD:
    'Per reimpostare la password, inserisci la tua e-mail di seguito.',
  PASSWORD_SENT: 'La password è stata inviata alla tua e-mail.',
  ADMIN_LOGIN: 'Accedi come amministratore',
  CREATE_COOK_ACCOUNT: 'Crea un profilo “Offro”',
  CREATE_GUEST_ACCOUNT: 'Crea un profilo “Cerco”',
  COOKIES:
    'Per migliorare il nostro sito Web e fornirti servizi personalizzati, vorremmo memorizzare i cookie sul tuo dispositivo.',
  READ_MORE: 'Leggi di più.',
  IMAGE_NOTE: '*l`immagine dovrebbe avere una dimensione massima di 400 kb',

  //Welcome screen
  GUEST_DESCRIPTION: `Voglio comprare deliziosi piatti da vari cuochi`,
  COOK_DESCRIPTION: `Voglio vendere il mio menu e cucinarlo con amore per gli ospiti`,
  GUEST_BUY_DESCRIPTION: 'Voglio trovare',
  GUEST_SELL_DESCRIPTION: 'Voglio offrire',
  I_AM_GUEST: `Cerco`,
  I_AM_COOK: `Offro`,

  //Date Picker Weekdays
  Mo: 'Lu',
  Tu: 'Ma',
  We: 'Me',
  Th: 'Gi',
  Fr: 'Ve',
  Sa: 'Sa',
  Su: 'Do',
  //Date Picker Months
  January: 'Gennaio',
  February: 'Febbraio',
  March: 'Marzo',
  April: 'Aprile',
  May: 'Maggio',
  June: 'Giugno',
  July: 'Luglio',
  August: 'Agosto',
  September: 'Settembre',
  October: 'Ottobre',
  November: 'Novembre',
  December: 'Dicembre',

  //restriction
  'Dairy Free': 'Senza lattosio',
  'Gluten Free': 'Senza glutine',
  Halal: 'Halal',
  Kosher: 'Kosher',
  'Nut Free': 'Senza noce',
  Organic: 'Organico',
  Vegan: 'Vegan',
  Vegetarian: 'Vegetarian',
  'Low Carb': 'Low Carb',
  Fitness: 'Fitness',
  'Sugar Free': 'Senza zucchero',
  Paleo: 'Paleo',
  GENERAL: 'Senza limiti',

  //ERROR HANDLER
  INPUT_FIRST_NAME: 'Si prega compilare tuo nome!',
  INPUT_LAST_NAME: 'Si prega compilare tuo cognome!',
  INPUT_USERNAME: 'Si prega compilare tuo nome dell’utente!',
  INPUT_DESCRIPTION: 'Si prega compilare tua descrizione!',
  INPUT_PHONE_NUMBER: 'Si prega compilare tuo numero di telefono!',
  INPUT_STREET: 'Si prega compilare tuo indirizzo!',
  INPUT_CITY: 'Si prega compilare la citta!',
  TIME_ERROR: 'Ci vuole più tempo di quanto preventivato.',
  CONSUMPTION_ERROR: 'Seleziona l’articolo da consumare',
  DATE_ERROR: 'Seleziona la data e l’ora',
  IMAGE_UPLOAD_ERROR: 'Si prega di caricare un’immagine',
  MEAL_NAME_ERROR: 'Si prega di inserire il nome del pasto!',
  MEAL_DESCRIPTION_ERROR: 'Si prega di compilare la descrizione del pasto!',
  PRICE_ERROR: 'Si prega di inserire il prezzo',
  RESCTRICTED_MESSAGE: 'Hai inserito alcune parole riservate.',

  // SUCCESS HANDLER
  'Profile Updated': 'Profile aggiornato',
  'Something went wrong': 'Qualcosa è andato storto',

  //meal filter
  'Meal Filter': 'Filtro pasto',
  Filter: 'Filtro',
  LOCATION: 'Locazione',
  NEAREST: 'Più vicino',
  FROM: 'Da',
  TO: 'A',
  SET: 'Impostare',
  MAX_PRICE: 'Mass prezzo',

  //update profile
  EDIT_PROFILE_HEADER_COOK: 'Crea il profilo come offro',
  EDIT_PROFILE_HEADER_GUEST: 'Crea il profilo come cerco',

  //edit meal
  'Edit Offer': 'Modifica offerta',
  'Editing Offer': 'Offerta di modifica',
  MAX_TIME: 'Tempo massimo',
  //Edit meal error
  FILL_TITLE: 'Si prega di inserire il nome del pasto!',
  FILL_DESCRIPTION: 'Si prega di compilare la descrizione del pasto!',
  FILL_PRICE: 'Si prega di inserire il prezzo',

  // PRODUCT CATEGORIES
  Handyman: 'Marito in affitto',
  Services: 'Servizi',
  Crafts: 'Mestieri',
  Tools: 'Attrezzi',

  'Friuts and vegetables': 'Frutta e verdura fresca',
  'Pickles, jams, marmelades': 'Frutta e verdura conservata',
  'Ready meals': 'Pasti pronti',
  Sweets: 'Torte e dolci',
  'Bakery products and pastry': 'Prodotti da forno',
  Herbs: 'Erbe',
  'Garden surpluses': 'Eccedenze da giardino',

  'Cosmetics, beauty and health': 'Cosmetica, bellezza e salute',
  Elecrtonics: 'Elettronica',

  'Kitchen and accessories': 'Cucina e accessori',
  Cooking: 'Cucinare',
  'Bathroom and accessories': 'Bagno e accessori',
  Furniture: 'Mobili',
  'Small furniture': 'Piccoli mobili',
  Matraces: 'Materassi',
  Decorations: 'Decorazioni',
  'Home accessories': 'Accessori per la casa',
  'Home textile': 'Tessili per la casa',
  'Pictures and frames': 'Immagini e cornici',
  Mirrors: 'Specchi',
  'Carpets and floorings': 'Tappeti e pavimenti',
  Heaters: 'Termoriscaldamento',
  Lights: 'Luci',
  Ventilators: 'Ventilatori',
  'Collecting, antique, arts': 'Collezionismo, antiquariato, arti',

  'Garden furniture': 'Mobili da giardino',
  Garden: 'Giardino',
  Flowers: 'Fiori',
  Grilling: 'Grigliate',
  'Dools and accessories': 'Piscine e accessori',

  Clothes: 'Abiti',
  Shoes: 'Scarpe',
  'Bags and luggages': 'Borse e bagagli',

  'Childerns accessories': 'Accessori per bambini',
  'Childrens furniture': 'Mobili per bambini',
  'Childrens clothes': 'Vestiti per bambini',
  'Childrens shoes': 'Scarpe per bambini',
  Toy: 'Giochi',
  'Books and textbooks': 'Libri e manuali',
  'Video games, films, CDs': 'Videogiochi, film, CD',
  'Music and musical instruments': 'Musica e strumenti musicali',

  'Sport accessories': 'Accessori per lo sport',
  'Sport clothes': 'Abiti sportivi',

  Cars: 'Macchine',
  Motorbiking: 'Moto',
  Cykling: 'Biciclette',

  'For pets': 'Per animali domestici',
  Others: 'Altro',

  // CARDS AND BANK DETAILS
  PAYMENT_CARD: 'Carta di pagamento',
  NEW_CARD: 'Nuova carta',
  BANK_ACCOUNT: 'Conto bancario',
  NEW_ACCOUNT: 'Nuovo conto',
  ACCOUNT_DETAILS: 'Dettagli di conto',

  CARD_DETAILS: 'Dettagli carta',
  CARD_NUMBER: 'Numero di carta',
  CARDHOLDER_NAME: 'Nome del titolare',
  IBAN: 'IBAN',
  ACCOUNT_NUMBER: 'Numero di conto',
  SWIFT_CODE: `SWIFT Codice/BIC`,
  BANK_NAME: 'Nome della banca',
  BANK_ADDRESS: 'Indirizzo della banca',

  INVALID_CARD_NUMBER: 'Numero di carta non valido',
  INVALID_CARD_EXPIRATION: 'Data di scadenza della carta non valida',
  INVALID_CVV: 'CVV carta non valido',

  EMPTY_PAYMENT_CARDS: `Non hai aggiunto alcuna carta.`,
  EMPTY_BANK_ACCOUNT: `Non hai aggiunto un account.`,
  DELETE_THIS_CARD: 'Vuoi veramente cancellare questa carta?',
  PAYMENT_THRESHOLD: 'Soglia di pagamento',
  PAYMENT_THRESHOLD_MESSAGE: `Riceverai il pagamento quando l'importo dovuto supera la soglia specificata.`,

  INPUT_HOLDERS_NAME: `Inserisci il nome del titolare!`,
  INPUT_ACCOUNT_NUMBER: `Inserisci il numero di conto!`,
  INPUT_IBAN: 'Inserisci IBAN!',
  INPUT_SWIFT_CODE: 'Inserisci il codice SWIFT / BIC!',
  INPUT_BANK_NAME: 'Inserisci il nome della banca!',
  INPUT_BANK_ADDRESS: 'Inserisci l’indirizzo della banca!',
  INPUT_PAYMENT_THRESHOLD: 'Inserisci la Soglia di Pagamento!',

  //Change Password
  STAY_LOGGED: 'Rimani connesso',
  CURRENT_PASSWORD: 'Password attuale',
  NEW_PASSWORD: 'Nuova password',
  PASSWORD_INVALID: 'La password attuale non è valida.',
  PASSWORD_CHARACTERS: 'La password deve contenere almeno 6 caratteri.',
};
export default translationIT;
